import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Flex } from '../Flex/index.js';

const ModalFooter = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Flex, _extends({
    ref: forwardedRef,
    as: "footer",
    borderTop: "1px solid",
    borderColor: "carbon100",
    justifyContent: "flex-end",
    px: "space60",
    py: "space50"
  }, rest), children);
});

export { ModalFooter };
